export const columns1 = [
  {
    label: 'No',
    key: 'No',
    minWidth: 80
  },
  {
    label: 'SolutionID',
    key: 'productId',
    minWidth: 120
  },
  {
    label: '运行状态',
    key: 'status',
    minWidth: 100
  },
  {
    label: '类型',
    key: 'productType'
  },
  {
    label: '客户',
    key: 'cname'
  },
  {
    label: '门店',
    key: 'shopName',
    className: 'text-overflow-ellipsis'
  },
  {
    label: 'retailx视频播放',
    key: 'cameraVideoSourceName',
    minWidth: 100,
    className: 'text-overflow-ellipsis'
  },
  {
    label: 'NVR数量',
    key: 'boxCount',
    minWidth: 100,
    align: 'right'
  },
  {
    label: '摄像头数量',
    key: 'cameraCount',
    align: 'right',
    minWidth: 110
  },
  {
    label: '操作',
    key: 'operation',
    width: 100,
    fixed: 'right',
    disabled: true
  }
]

export const brandNameMap = {
  DA_HUA: '大华',
  JVS: '中维',
  HIKVISION: '海康威视'
}
